import React from 'react'
import { Card, CardItem } from '../../../../../../../../components/Card';
import { StyledCurrentValue } from './styled';

function CurrentTemperature({ current }) {
    return (
        <Card>
            <CardItem
                left={{
                    name: current.title,
                    value: <StyledCurrentValue state={current.state}>{current.value}</StyledCurrentValue>
                }}
            />
        </Card>
    )
}

export default CurrentTemperature
